<template>
  <v-container fluid>
    <v-layout justify-start v-if="!isSystemSalesRoleOnly">
      <v-btn color="primary" :disabled="featuresManagementButtonDisabled" @click.stop="showFeatureEditDialog">{{$t('editFeatures')}}</v-btn>
      <v-btn color="primary" :disabled="!canManageSystemOfflineDeposit" @click.stop="showOfflineDepositDialog">{{ $t('offlineDeposit') }}
        <v-badge class="openBadge" :value="checkNewOffline" color="red" overlap>
           <template v-slot:badge>
            <span class="badge">{{ $t('new') }}</span>
           </template>
          </v-badge>
      </v-btn>
      <v-btn color="primary" @click.stop="showApplicationDialog">{{$t('featureApplication')}}</v-btn>
      <v-btn color="primary" @click.stop="showDayEndClosingDialog">{{$t('dayEndClosing')}}</v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            v-on="on"
          >
            {{ $t('export') }}
            <v-icon size="20">expand_more</v-icon>
          </v-btn>
        </template>
        <template v-if="!isSystemSalesRoleOnly">
          <v-list dark class="primary menu-list-btn" @click.native.stop="() => exportTableData()">
            {{ $t('exportClientExpense') }}
          </v-list>
        </template>
        <v-list dark class="primary menu-list-btn" @click.native.stop="showExportClientsRechargeTransactionDialog">
          {{$t('exportClientsRechargeTransaction')}}
        </v-list>
        <template v-if="!isSystemSalesRoleOnly">
          <v-list dark class="primary menu-list-btn" @click.native.stop="exportTableDataDetail">
            {{ $t('exportClientExpenseDetail') }}
          </v-list>
        </template>
      </v-menu>
    </v-layout>
    <v-layout justify-space-between align-baseline>
      <v-flex md5 class="success--text caption">
        <v-layout row align-end justify-space-between>
          <v-flex>
            <span class="realtime-border px-1">{{ $t('realTIME') }}</span>
          </v-flex>
          <v-flex>
            <v-autocomplete
              hide-details
              :label="$t('clientType')"
              v-model="filterClientType"
              :items='clientTypeList'
              item-value="type"
              item-text="text"
              clearable></v-autocomplete>
          </v-flex>
          <v-flex class="modes">
            <v-autocomplete
              hide-details
              :label="$t('mode')"
              v-model="modeType"
              :items='modeList'
              item-value="type"
              item-text="text"
              clearable></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-flex>
      <template  v-if="hasAuthToFunctionality('sysfinancialReport')">
        <!-- <v-flex md2 v-for="num in [0, 1, 2]" :key="num">
          {{ getExpenseHeader(num) }}: ${{ totalExpense3Months[num].toLocaleString() }}
        </v-flex> -->
        <v-flex md2>
          <v-btn
            color="primary"
            flat
            icon
            @click.stop="showExpenseHistoryDialog(totalExpenseHistory)"
          >
            <v-icon color="info">info</v-icon>
          </v-btn>
        </v-flex>
      </template>
      <!-- <v-flex md2 v-if="!isSystemSalesRoleOnly">
        <v-btn
          color="primary"
          @click.stop="() => exportTableData()"
        >
          {{ $t('export') }}
        </v-btn>
        <v-btn
          color="primary"
          @click.stop="exportTableDataDetail"
        >
          {{ $t('exportClientExpenseDetail') }}
        </v-btn>
      </v-flex> -->
      <v-flex md2>
        <v-text-field
          :label="$t('filter')"
          v-model="filter"
          hide-details
          clearable
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="balanceHeaders"
      :items="balances"
      class="elevation-1"
      :search="filter"
      :rows-per-page-items="rowPerPage"
      :pagination.sync="pagination">
      <template v-slot:items="{item}">
        <td class="subheading">
          <v-tooltip top>
              <template v-slot:activator="tooltip">
                <div v-on="tooltip.on">
                  <v-layout>
                    <strong>
                      <v-icon v-if="item.type === 'warehouse'" style="font-size:20px">local_shipping</v-icon>
                      <v-icon v-if="item.type === 'organization'" style="font-size:20px">business</v-icon>
                      <v-icon v-if="item.isBlockCreditCardDeposit" style="font-size:20px">strikethrough_s</v-icon>
                    </strong>
                    <span class="text-overflow-hide" :ref="`${item.clientKey}-name`" @click="toggleOverflowStyle(`${item.clientKey}-name`)" style="color: black;font-weight: bolder;cursor: pointer">{{ item.clientName }}{{ item.companyName ? `(${item.companyName})` : ''}}</span>
                  </v-layout>
                  <v-layout v-if="item.orgKey || item.apiKey || item.mode === 'label'">{{ $t('mode') }}: {{ $t('label') }}</v-layout>
                  <v-layout>({{ item.email }})</v-layout>
                </div>
              </template>
              {{ $t('registTime') + ': ' + toTimestampString(item.createTime)}}
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <div v-if="item.contractSigning" style="font-size: 12px;">
            {{ item.contractSignStartDate && item.contractSignStartDate.toISOString().slice(0, 10) }}
            <br/> ~ <br/>
            {{ item.contractSignEndDate && item.contractSignEndDate.toISOString().slice(0, 10) }}
          </div>
        </td>
        <td class="text-xs-center"><v-icon v-if="item.status">check_circle</v-icon></td>
        <td class="text-xs-center"><v-icon v-if="isImportServiceAvailable && item.isOverseaCustomer">check_circle</v-icon></td>
        <td class="text-xs-left">
          <v-layout justify-start align-center>
            <v-flex>
              <v-chip v-for="tag in item.tags" :key="tag">{{ tag }}</v-chip>
            </v-flex>
            <v-flex md2>
              <v-icon small @click="showEditTagsPopup(item)">edit</v-icon>
            </v-flex>
          </v-layout>
        </td>
        <td class="text-xs-left">
          <v-layout justify-start align-center>
            <v-flex>
              ${{ item.balance && item.balance.toLocaleString() }}
            </v-flex>
            <v-flex v-if="item.orgKey || item.apiKey || item.mode === 'label'" md2 class="align-right">
              <LoaderButton
                flat
                isSmall
                class="refreshBalance"
                :promiseAwait="refreshBalance"
                :promiseItem="item"
              >
                <template v-slot:icon>
                  <v-icon>refresh</v-icon>
                </template>
              </LoaderButton>
            </v-flex>
          </v-layout>
        </td>
        <td class="text-xs-left" v-if="isShowMargin">{{ item.margin || 0 }}%</td>
        <td class="text-xs-left" v-if="isShowMonthlyFee">${{ item.monthlyFee || 0 }}</td>
        <td class="text-xs-left">${{ item.lowestBalance || 0 }}/${{ item.bond || 0 }} </td>
        <td class="text-xs-left">{{ `${item.department || 'N/A'} / ${item.accountManager || 'N/A'}` }}</td>
        <td class="text-xs-left">
          <div class="text-overflow-hide" style="cursor: pointer" :ref="`${item.clientKey}-note`" @click="toggleOverflowStyle(`${item.clientKey}-note`)">{{item.note}}</div>
        </td>
        <td class="text-xs-left" v-if="!roles.includes('sysAdminOverseaOperator')">${{ getExpense(item.expenseHistory, 0).toLocaleString() }}</td>
        <td class="text-xs-left" v-if="!roles.includes('sysAdminOverseaOperator')">${{ getExpense(item.expenseHistory, 1).toLocaleString() }}</td>
        <td class="text-xs-left" v-if="!roles.includes('sysAdminOverseaOperator')">${{ getExpense(item.expenseHistory, 2).toLocaleString() }}</td>
        <td class="text-xs-left">
          <v-layout justify-center>
            <v-tooltip top v-if="!isSystemSalesRoleOnly">
              <template v-slot:activator="tooltip">
                <div v-on="tooltip.on">
                  <v-btn icon @click.stop="showConfigDialog(item)" color="primary" flat><v-icon>edit</v-icon></v-btn>
                </div>
              </template>
              {{ $t('edit') }}
            </v-tooltip>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-tooltip top>
                  <template v-slot:activator="tooltip">
                    <div v-on="tooltip.on">
                      <v-btn icon @click.stop="on.click" color="primary" flat><v-icon>build</v-icon></v-btn>
                     </div>
                  </template>
                  {{ $t('more') }}
                </v-tooltip>
              </template>
              <v-list>
                <v-list-tile v-if="!isSystemSalesRoleOnly && !(item.orgKey || item.mode === 'label')" :disabled="!canAdjustSystemBalance" @click.stop="showAdjustDialog(item)">
                  <v-list-tile-title>{{ $t('adjust') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click.stop="showExpenseHistoryDialog(item.expenseHistory)">
                  <v-list-tile-title>{{ $t('history') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click.stop="showDetailDialog(item)">
                  <v-list-tile-title>{{ $t('detail') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click.stop="showLabelInvoicesDialog(item)">
                  <v-list-tile-title>{{ $t('invoice') }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-layout>
        </td>
      </template>
    </v-data-table>
    <AdjustBalancePopup
      v-if="adjustBalanceDialog"
      v-model="adjustBalanceDialog"
      :adjustment="adjustBalance"
      :actionFunc="addAdjustBalance"/>
    <ExpenseHistoryPopup
      v-if="expenseHistoryDialog"
      v-model="expenseHistoryDialog"
      :expenseHistory="expenseHistory"/>
    <FormSubmitPopup
      :title="$t('featuresManagement')"
      v-model="featureDialog"
      v-if="featureDialog"
      medium
      @popupClose="featureDialog = false"
      :rightMethod="editFeature"
      :rightButtonDisabled="featuresManagementButtonDisabled"
      :rightButtonText="$t('submit')">
      <template v-slot:input>
        <v-container>
          <!-- <v-layout justify-space-between>
            <v-flex>
              <v-autocomplete
                v-model="labelAndOrder"
                :label="$t('labelAndOrder')"
                :items="clientsDisplay"
                item-text="name"
                item-value="key"
                chips
                multiple
                deletable-chips
                clearable></v-autocomplete>
            </v-flex>
          </v-layout> -->
          <v-layout justify-space-between>
            <v-container fluid>
              <v-layout>
                <v-flex md3>
                  <v-text-field
                    :label="$t('apiId')"
                    v-model="eeveeOrgIdDisplay"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-container
              class="grey lighten-5 mb-6">
                <v-layout row v-for="(item, index) in fullBetaFeatures.filter(item => item.type !== 'payment')"  :key="item.displayName + index">
                  <v-flex md5>
                    <v-checkbox
                    v-model="features"
                    :value="item.key"
                    :label="item.displayName"
                    @change="changeFeature(item)"
                  ></v-checkbox>
                  </v-flex>
                  <v-flex md3>
                    <v-switch
                    :disabled="!features.includes(item.key)"
                    v-model="item.isVisible"
                    :label="$t(item.isVisible ? 'visible' : 'inVisible')"
                  ></v-switch>
                  </v-flex>
              </v-layout>
              <h3>{{ $t('pay') }}</h3>
              <v-layout row v-for="(item, index) in fullBetaFeatures.filter(item => item.type === 'payment')"  :key="item.displayName + index">
                  <v-flex md5>
                    <v-checkbox
                    v-model="features"
                    :value="item.key"
                    :label="item.displayName"
                    @change="changeFeature(item)"
                  ></v-checkbox>
                  </v-flex>
                  <v-flex md3>
                    <v-switch
                    :disabled="!features.includes(item.key)"
                    v-model="item.isVisible"
                    :label="$t(item.isVisible ? 'visible' : 'inVisible')"
                  ></v-switch>
                  </v-flex>
              </v-layout>
              </v-container>
            </v-container>
          </v-layout>
        </v-container>
      </template>
    </FormSubmitPopup>
    <FormSubmitPopup
      :title="$t('clientConfig')"
      v-model="configDialog"
      v-if="configDialog"
      medium
      @popupClose="configDialog = false"
      :rightMethod="editConfig"
      :rightButtonText="$t('submit')">
      <template v-slot:input>
        <v-container>
          <v-layout v-if="!clientInEdit.isModeLabel">
            <v-flex md6>
              <v-text-field
                :label="$t('minBalance')"
                prefix="$"
                v-model.number="clientInEdit.lowestBalance"
                :rules="[fieldIsNumber()]"></v-text-field>
            </v-flex>
            <v-flex md6>
              <v-text-field
                :label="$t('bond')"
                prefix="$"
                v-model.number="clientInEdit.bond"
                :rules="[fieldIsNumber()]"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="!clientInEdit.isModeLabel">
            <v-flex md6>
              <v-layout justify-space-between>
                <v-flex md6>
                  <v-select
                    :label="$t('department')"
                    :items="departments"
                    item-text="name"
                    item-value="name"
                    clearable
                    v-model="clientInEdit.department"></v-select>
                </v-flex>
                <v-flex md5>
                  <v-select
                    :label="$t('accountManager')"
                    :items="accountManagers"
                    clearable
                    v-model="clientInEdit.accountManager"></v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md6>
              <v-layout>
                <v-flex v-if="isShowMonthlyFee">
                  <v-text-field
                    :label="$t('monthlyFee')"
                    prefix="$"
                    v-model="clientInEdit.monthlyFee"
                    :rules="[fieldIsNumber()]"></v-text-field>
                </v-flex>
                <v-spacer v-if="isShowMonthlyFee && isShowMargin"></v-spacer>
                <v-flex v-if="isShowMargin">
                  <v-text-field
                    :label="$t('margin')"
                    suffix="%"
                    v-model="clientInEdit.margin"
                    :rules="[fieldIsNumber()]"></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3>
              <v-text-field
                :label="$t('companyName')"
                v-model="clientInEdit.companyName"
              ></v-text-field>
            </v-flex>
            <v-flex md2>
              <v-checkbox
                :label="$t('blockCreditCardDeposit')"
                v-model="clientInEdit.isBlockCreditCardDeposit"
              ></v-checkbox>
            </v-flex>
            <v-flex md2>
              <v-checkbox
                :label="$t('contractSigning')"
                v-model="clientInEdit.contractSigning"
                ></v-checkbox>
            </v-flex>
            <v-flex md3 v-if="clientInEdit.contractSigning">
              <DatePicker
                :label="$t('contractSigningValidDate')"
                range
                v-model="clientInEdit.contractSigningValidDate"
                :rules="[v => (!v[0] || !v[1]) && $t('required')]"
                ></DatePicker>
            </v-flex>
          </v-layout>
          <v-layout v-if="clientInEdit.type === 'organization'">
            <v-flex md3>
              <v-text-field
                :label="$t('apiId')"
                v-model="clientInEdit.eeveeOrgId"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="clientInEdit.type === 'organization'">
            <v-flex md3>
              <v-text-field
                :label="$t('weChatGroupId')"
                v-model="clientInEdit.weChatGroupId"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="clientInEdit.type === 'warehouse'" align-center>
            <v-flex md3>
              <v-checkbox :label="$t('labelMapping')" v-model="clientInEdit.labelMapping"></v-checkbox>
            </v-flex>
            <v-flex v-if="clientInEdit.labelMapping">
              <v-text-field
                :label="$t('scanLabelTotal')"
                readonly
                v-model="scanLabelTotal">
              </v-text-field>
            </v-flex>
            <v-flex v-if="clientInEdit.labelMapping">
              <v-btn flat @click="isShowScanLabelStatisticsDetail = true">{{$t('detail')}}</v-btn>
            </v-flex>
          </v-layout>
          <v-layout v-if="clientInEdit.type === 'warehouse'">
            <v-flex md6>
              <v-layout justify-space-between>
                <v-flex md6>
                  <v-text-field
                    :label="$t('extraDepositFee')"
                    suffix="%"
                    v-model="clientInEdit.depositFeePercent"
                    :rules="[fieldIsNumber()]"></v-text-field>
                </v-flex>
                <v-flex md4>
                  <v-checkbox
                    :label="$t('disableOutbound')"
                    v-model="clientInEdit.isDisabledOutbound"
                    ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md7>
              <v-layout justify-space-between align-center>
                <v-flex md5>
                  <v-text-field
                    :label="$t('clientKey')"
                    readonly
                    :value="clientInEdit.clientKey"
                    >
                      <template v-slot:append>
                        <v-icon color="primary" @click.stop="copyToClipboard(clientInEdit.clientKey)">content_copy</v-icon>
                      </template>
                    </v-text-field>
                </v-flex>
                <v-flex md5 ml-3>
                  <v-text-field
                    :label="$t('clientName')"
                    readonly
                    :value="clientInEdit.clientName"
                    >
                      <template v-slot:append>
                        <v-icon color="primary" @click.stop="copyToClipboard(clientInEdit.clientName)">content_copy</v-icon>
                      </template>
                    </v-text-field>
                </v-flex>
                <v-flex md5 ml-3>
                  <v-text-field
                    :label="$t('email')"
                    readonly
                    :value="clientInEdit.email"
                    >
                      <template v-slot:append>
                        <v-icon color="primary" @click.stop="copyToClipboard(clientInEdit.email)">content_copy</v-icon>
                      </template>
                    </v-text-field>
                </v-flex>
                <v-flex md1 ml-3>
                  <v-btn flat @click.stop="copyToClipboard(clientInfoText)">{{$t('copyAll')}}</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-autocomplete
                v-model="clientInEdit.features"
                :label="$t('features')"
                :items="enableBetaFeatures"
                chips
                multiple
                item-text="displayName"
                item-value="key"
                deletable-chips
                clearable></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-autocomplete
                v-model="clientInEdit.inVisibleFeatures"
                :label="$t('unVisibleFeature')"
                :items="enableBetaFeatures"
                chips
                multiple
                item-text="displayName"
                item-value="key"
                deletable-chips
                clearable></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout v-if="(clientInEdit.features || []).includes('FEDEX_LTL')">
            <v-flex>
              <v-autocomplete
                v-model="clientInEdit.freightSites"
                :label="$t('freightSites')"
                :items="['ALL', ...freightSites.map(site => site.siteId)]"
                chips
                multiple
                deletable-chips
                clearable
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-textarea
              :label="$t('note')"
              outline
              v-model="clientInEdit.note"
              rows="5"
              counter="10000"
              class="thinBox"></v-textarea>
          </v-layout>
        </v-container>
      </template>
    </FormSubmitPopup>
    <FormSubmitPopup
      :title="$t('application')"
      v-model="applicationDialog"
      v-if="applicationDialog"
      medium
      @popupClose="applicationDialog = false"
      :hideRgtBtn="true">
    >

      <template v-slot:input>
      <v-tabs
      color="transparent"
      v-model="tab"
      show-arrows
      >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab
        v-for="(tabItem) in applicationTabs"
        :key="tabItem"
      >
        <span class="tabItem">
          {{ $t(tabItem.toLowerCase()) }}
        </span>
      </v-tab>
      <v-tab-item v-for="(item, index) in applicationTabs.length" :key="'item' + index">
          <PaginationController
          v-if="index === 0"
          ref="applicationTableController"
          v-model="applicationList"
          getDataActionName="getApplicationList"
          :actionPredicates="actionPredicates"
          :historyLimit="25"
          :haveStartDate="false"
          :haveNoEndDate="true"
          :showSearchBoxLabel="false"
          :outsideScrollToBottom="false"
          :searchBoxLabel="$t('searchForKeywords')"
          :refresh="refreshTable"
          >
            <template v-slot:dataTable>
              <v-data-table
                  :headers="applicationHeaders"
                  :items="applicationList"
                  item-key="_key"
                  class="elevation-2 myDense"
                >
                  <template v-slot:items="{item}">
                    <td>{{item.name}}</td>
                    <td class="text-xs-left">{{ item.feature }}</td>
                    <td class="text-xs-left">{{ toTimestampString( item.createTime ) }}</td>
                    <td class="text-xs-left">
                      <v-btn @click="downloadFile(item.uploadFiles[0])">{{ item.uploadFiles[0].name }}</v-btn>
                    </td>
                    <td class="text-xs-center">
                      <v-flex row align-center>
                        <v-btn color="primary" flat dark icon @click="handleApplication('success', item)" :loading="item.loading"><v-icon dark>check</v-icon></v-btn>
                        <v-btn color="red" flat dark icon @click="handleApplication('reject', item)" :loading="item.loading"><v-icon dark>cancel</v-icon></v-btn>
                        <v-btn color="primary" flat dark icon @click="showCommentsDialog(item)" :loading="item.loading"><v-icon dark>comment</v-icon></v-btn>
                      </v-flex>
                    </td>
                  </template>
            </v-data-table>
            </template>
          </PaginationController>
          <PaginationController
          v-if="index === 1 && tab === 1"
          ref="historyApplicationTableController"
          v-model="historyApplicationList"
          getDataActionName="getApplicationList"
          :actionPredicates="historyActionPredicates"
          :historyLimit="25"
          :outsideScrollToBottom="false"
          :searchBoxLabel="$t('searchForKeywords')"
          :haveStartDate="false"
          :haveNoEndDate="true"
          :refresh="refreshTable"
          >
            <template v-slot:dataTable>
              <v-data-table
                  :headers="historyApplicationHeaders"
                  :items="historyApplicationList"
                  item-key="_key"
                  class="elevation-2 myDense"
                >
                  <template v-slot:items="{item}">
                    <td>{{item.name}}</td>
                    <td class="text-xs-left">{{ item.feature }}</td>
                    <td class="text-xs-left">{{ toTimestampString( item.createTime ) }}</td>
                    <td class="text-xs-left">
                      <v-btn @click="downloadFile(item.uploadFiles[0])">{{ item.uploadFiles[0].name }}</v-btn>
                    </td>
                  </template>
            </v-data-table>
            </template>
          </PaginationController>
      </v-tab-item>
    </v-tabs>
      </template>
    </FormSubmitPopup>
    <ChatRoom
      v-model="commentsDialog"
      v-if="commentsDialog"
      :docPath="['featureApplication', applicationInSupport._key]"
      :comments="comments"
      :createConnection="true"
      >
      <template v-slot:issue>
        <v-card hover raised>
          <v-card-text>
            <div class="cardTitle" style="overflow-wrap: break-word;">{{ $t('createTime') }}: {{ toTimestampString(applicationInSupport.createTime) }}</div>
            <div class="cardTitle" style="overflow-wrap: break-word;">{{ $t('tenant') }}: {{ applicationInSupport.name }}</div>
            <div class="cardTitle" style="overflow-wrap: break-word;">{{ $t('featureApplication') }}: {{ applicationInSupport.feature }}</div>
            <br />
            <div class="cardTitle" style="overflow-wrap: break-word;">
              {{ $t('files') }}:
            <v-btn  @click="downloadFile(applicationInSupport.uploadFiles[0])" >{{ applicationInSupport.uploadFiles[0].name }}</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </ChatRoom>
    <BillingDetails
      v-model="billingDetailDialog"
      v-if="billingDetailDialog"
      :tenantKey="clientInView"
      :client="clientItemInView"
      warehouseKey="system"/>
    <LabelInvoiceDetails
      v-if="labelInvoiceDetailDialog"
      v-model="labelInvoiceDetailDialog"
      :tenantKey="selectedClientKey"
      :selectedClientInfo="selectedClientInfo"
    />
    <OfflineDepositPopup
      v-model="OfflineDepositDialog"
      v-if="OfflineDepositDialog"/>
    <DayEndClosingPopup
      v-model="dayEndClosingDialog"
      v-if="dayEndClosingDialog"
      :clients="balances"
    />
    <SimpleTextPopup
      v-model="isShowEditTagsPopup"
      v-if="isShowEditTagsPopup"
      @popupClose="() => this.isShowEditTagsPopup = false"
      :rightMethod="saveTags"
      :title="$t('tag')"
      >
      <template v-slot:input>
        <v-combobox
          :items="activeTagsList"
          v-model="currentItemTagKeys"
          item-text="displayName"
          item-value="key"
          :label="$t('clientTag')"
          :return-object="false"
          chips
          multiple
          clearable />
      </template>
    </SimpleTextPopup>
    <SimpleTextPopup
      v-model="isShowScanLabelStatisticsDetail"
      v-if="isShowScanLabelStatisticsDetail"
      @popupClose="() => this.isShowScanLabelStatisticsDetail = false"
      :title="$t('statistics')"
      hideRgtBtn
      medium
      >
      <template v-slot:input>
        <v-layout row justify-space-between>
          <v-flex xs6 md6>
          <v-menu
            :close-on-content-click="false"
            v-model="startMenu"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="data">
              <v-text-field
                v-model="startDateString"
                :label="$t('startDate')"
                prepend-icon="event"
                readonly
                v-on="data.on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="startDateString"
              @input="startMenu = false"
              :min="tab === 1 ? (selectedStat[0] ? selectedStat[0].dateKeyStr : '') : ''"></v-date-picker>
          </v-menu>
          </v-flex>
          <v-flex md6>
            <v-menu
              :close-on-content-click="false"
              v-model="endMenu"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="data">
                <v-text-field
                  v-model="endDateString"
                  :label="$t('endDate')"
                  prepend-icon="event"
                  readonly
                  v-on="data.on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDateString"
                @input="endMenu = false"
                :min="tab === 1 ? (selectedStat[0] ? selectedStat[0].dateKeyStr : '') : ''"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
          <v-data-table
            :headers="historyHeaders"
            :items="matchedDailyScanLabelStats"
          >
            <template v-slot:items="props">
                <td class="subheading">{{ props.index + 1}}</td>
                <td class="text-xs-left">{{ props.item.dateKeyStr }}</td>
                <td class="text-xs-left">{{ props.item.scanItems }}</td>
            </template>
          </v-data-table>
      </template>
    </SimpleTextPopup>
    <ExportClientsRechargeTransactionPopup
      v-if="exportClientsRechargeTransactionDialog"
      v-model="exportClientsRechargeTransactionDialog"
      :clients="balances"
    />
    <ExportClientExpenseDetailsPopup
      v-if="!isSystemSalesRoleOnly"
      v-model="exportClientsExpenseDetailsDialog"
      :exportTableData="exportTableData"
    />
  </v-container>
</template>

<script>
import Label from './Label'
import ExpenseHistoryPopup from './ExpenseHistoryPopup'
import add from 'date-fns/add'
import BillingDetails from './BillingDetails'
import LabelInvoiceDetails from './LabelInvoiceDetails'
import PaginationController from './PaginationController'
import ExportClientsRechargeTransactionPopup from './exportClientsRechargeTransactionPopup'
import ChatRoom from '@/components/ChatRoom'
import { checkRules, toMoney, splitKeyword, copyText, timeTools } from '@/utils/tools'
import OfflineDepositPopup from './OfflineDepositPopup'
import {thirdPartModuleConfig} from '../../config/moduleConfig'
import AdjustBalancePopup from './AdjustBalancePopup'
import DayEndClosingPopup from './DayEndClosingPopup.vue'
import DatePicker from './DatePicker'
import { mapGetters } from 'vuex'
import SimpleTextPopup from './SimpleTextPopup.vue'
import ExportClientExpenseDetailsPopup from './ExportClientExpenseDetailsPopup.vue'
import xlsx from 'xlsx'

const ALL_EXPENSE_MONTHS_COUNT = 24
export default {
  name: 'LabelAdmin',
  extends: Label,
  mixins: [checkRules, timeTools],
  components: {
    ExpenseHistoryPopup,
    BillingDetails,
    LabelInvoiceDetails,
    OfflineDepositPopup,
    PaginationController,
    ChatRoom,
    AdjustBalancePopup,
    DayEndClosingPopup,
    SimpleTextPopup,
    DatePicker,
    ExportClientsRechargeTransactionPopup,
    ExportClientExpenseDetailsPopup
  },
  data () {
    return {
      adjustBalanceDialog: false,
      adjustBalance: {
        amount: 0,
        note: '',
        type: 'balance',
        keywords: ''
      },
      selectedBalance: {},
      selectedBalanceTable: {},
      curKeyStr: '',
      expenseHistoryDialog: false,
      expenseHistory: [],
      featureDialog: false,
      labelAndOrder: [],
      // clients: [],
      clientsDisplay: [],
      clientInEdit: {
        accountManager: ''
      },
      configDialog: false,
      applicationDialog: false,
      rowPerPage: [30, 100, {text: this.$t('all'), value: -1}],
      pagination: {
        sortBy: 'expense0',
        descending: true
      },
      clientInView: null,
      clientItemInView: null,
      billingDetailDialog: false,
      labelInvoiceDetailDialog: false,
      selectedClientKey: '',
      selectedClientInfo: null,
      filter: '',
      OfflineDepositDialog: false,
      features: [],
      eeveeOrgIdDisplay: '',
      isShowFreightSites: false,
      filterClientType: '',
      modeType: '',
      clientTypeList: [
        {type: 'organization', text: 'organization'},
        {type: 'warehouse', text: 'warehouse'}
      ],
      applicationTabs: [ this.$t('active'), this.$t('history') ],
      applicationList: [],
      historyApplicationList: [],
      historyActionPredicates: [
        {
          field: 'status',
          compare: '==',
          value: 'success'
        }
      ],
      actionPredicates: [
        {
          field: 'status',
          compare: '==',
          value: 'pending'
        }
      ],
      applicationHeaders: [
        { text: this.$t('name'), value: 'tenantName', align: 'left', sortable: false },
        { text: this.$t('applyFeature'), value: 'feature', align: 'left', sortable: false },
        { text: this.$t('requestTime'), value: 'requestTime', align: 'left', sortable: false },
        { text: this.$t('applicationDocuments'), value: 'uploadFiles[0].name', align: 'left', sortable: false },
        { text: this.$t('actions'), value: '', width: '20%', align: 'center', sortable: false }
      ],
      historyApplicationHeaders: [
        { text: this.$t('name'), value: 'tenantName', align: 'left', sortable: false },
        { text: this.$t('applyFeature'), value: 'feature', align: 'left', sortable: false },
        { text: this.$t('requestTime'), value: 'requestTime', align: 'left', sortable: false },
        { text: this.$t('applicationDocuments'), value: 'uploadFiles[0].name', align: 'left', sortable: false }
      ],
      commentsDialog: false,
      applicationInSupport: {},
      refreshTable: false,
      dayEndClosingDialog: false,
      currentItemTagKeys: [],
      isShowEditTagsPopup: false,
      startDateString: this.toPickerDateString(new Date(Date.now() - 1000 * 60 * 60 * 24 * 19)), // 15 business days ag
      startMenu: false,
      endDateString: this.toPickerDateString(new Date()),
      endMenu: false,
      isShowScanLabelStatisticsDetail: false,
      exportClientsRechargeTransactionDialog: false,
      exportClientsExpenseDetailsDialog: false
    }
  },
  async created () {
    !this.freightSites.length && this.$store.dispatch('getFreightSites')
    this.$store.dispatch('getAllSystemBalances')
    this.$store.dispatch('loadSystemInfo')
    // this.clients = await this.$store.dispatch('getAllLimitedInfo')
    this.$store.dispatch('buildAllLimitedInfoRT')
    if (this.canManageSystemOfflineDeposit) this.$store.dispatch('getOfflineDeposits')
    this.clientsDisplay = [
      {key: 'all', name: '-All-'},
      ...this.clients.map(client => {
        let {name, type, key} = client
        return {
          name: `${name}(${type})`,
          key
        }
      })
    ]
    const currentTime = new Date()
    this.curKeyStr = `${currentTime.getFullYear()}-${currentTime.getMonth() + 1}`
  },
  computed: {
    modeList () {
      return [
        {type: '', text: this.$t('all')},
        {type: 'api', text: this.$t('apiClient')},
        {type: 'vite', text: this.$t('viteClient')}
      ]
    },
    ...mapGetters(['departments', 'isSystemSalesRoleOnly']),
    freightSites () {
      return this.$store.getters.freightSites || []
    },
    checkNewOffline () {
      return (this.$store.getters.offlineDeposits && this.$store.getters.offlineDeposits.some(item => item.status === 'open'))
    },
    balanceMap () {
      return new Map(this.$store.getters.systemBalances.map(item => [item.clientKey, item]))
    },
    balances () {
      return this.clientInShow.reduce((balances, client) => {
        let {name, key, email, betaFeatures = [], type, inVisibleFeatures, createTime, tags} = client
        let status = this.labelAndOrderEnabled && betaFeatures.includes('labelAndOrder')
        let isOverseaCustomer = betaFeatures.includes('oversea')
        let balanceStat = this.balanceMap.get(key)
        let expense0 = balanceStat && this.getExpense(balanceStat.expenseHistory, 0)
        let expense1 = balanceStat && this.getExpense(balanceStat.expenseHistory, 1)
        let expense2 = balanceStat && this.getExpense(balanceStat.expenseHistory, 2)
        if (this.isSystemSalesRoleOnly) {
          if (this.balanceMap.has(key)) {
            balances.push({...balanceStat, status, email, expense0, expense1, expense2, betaFeatures, type, isOverseaCustomer, inVisibleFeatures, createTime})
          }
        } else {
          if (this.balanceMap.has(key)) {
            balances.push({...balanceStat, status, email, expense0, expense1, expense2, betaFeatures, type, isOverseaCustomer, inVisibleFeatures, createTime})
            return balances
          }
          balances.push({
            balance: 0,
            clientKey: key,
            clientName: name,
            status,
            email,
            betaFeatures,
            type,
            isOverseaCustomer,
            createTime,
            tags
          })
        }
        return balances
      }, [])
    },
    fullBetaFeatures () {
      return this.$store.getters.fullBetaFeatures
    },
    featuresManagementButtonDisabled () {
      return !this.fullBetaFeatures?.length
    },
    visibleBetaFeatures () {
      return this.$store.getters.visibleBetaFeatures
    },
    enableBetaFeatures () {
      return this.$store.getters.fullBetaFeatures.filter(feature => {
        return feature.isEnabled
      })
    },
    eeveeOrgId () {
      return this.$store.getters.eeveeOrgId
    },
    labelAndOrderEnabled () {
      return this.enableBetaFeatures.some(feature => feature.key === 'labelAndOrder')
    },
    isImportServiceAvailable () {
      return this.enableBetaFeatures.some(feature => feature.key === 'oversea')
    },
    totalExpense3Months () {
      return Array(3).fill(0).map((zero, num) => {
        return toMoney(this.balances.reduce((acc, item) => {
          return acc + this.getExpense(item.expenseHistory, num)
        }, 0))
      })
    },
    totalExpenseHistory () {
      return Array(ALL_EXPENSE_MONTHS_COUNT).fill(0).map((zero, num) => {
        let currentTime = add(new Date(), {months: -num})
        return {
          dateKeyStr: `${currentTime.getFullYear()}-${currentTime.getMonth() + 1}`,
          expense: toMoney(this.balances.reduce((acc, item) => {
            return acc + this.getExpense(item.expenseHistory, num)
          }, 0))
        }
      })
    },
    roles () {
      return this.$store.getters.user.roles
    },
    canManageSystemOfflineDeposit () {
      return this.hasAuthToFunctionality('sysBillingOfflineDeposit')
    },
    canAdjustSystemBalance () {
      return this.hasAuthToFunctionality('sysBillingAdjustBalance')
    },
    balanceHeaders () {
      const headers = [
        { text: this.$t('name'), value: 'clientName', align: 'left', sortable: true },
        { text: this.$t('contractSigning'), value: 'contractSigning', align: 'center', sortable: true },
        { text: this.$t('label'), value: 'status', align: 'left', sortable: true },
        { text: this.$t('oversea'), value: 'isOverseaCustomer', align: 'left', sortable: true },
        { text: this.$t('tags'), value: 'tags', align: 'left', sortable: true, width: '8%' },
        { text: this.$t('balance'), value: 'balance', align: 'left', sortable: true },
        { text: this.$t('margin'), value: 'margin', align: 'left', sortable: true },
        { text: this.$t('monthlyFee'), value: 'monthlyFee', align: 'left', sortable: true },
        { text: this.$t('minBalanceBond'), value: 'minBalanceBond', align: 'left', sortable: false },
        { text: this.$t('department'), value: 'department', align: 'left', sortable: false },
        { text: this.$t('registTime'), value: 'createTime', align: 'left', sortable: false, class: 'header-hidden' },
        { text: this.$t('note'), value: 'note', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('actions'), value: 'email', align: 'center', sortable: false, width: '10%' }
      ]
      if (!this.roles.includes('sysAdminOverseaOperator')) {
        headers.splice(headers.length - 1, 0, ...[0, 1, 2].map(item => ({
          text: `${this.getExpenseHeader(item)}`, value: `expense${item}`, align: 'left', sortable: true
        }))
        )
      }
      return this.filterByModule(headers)
    },
    historyHeaders () {
      const headers = [
        { text: this.$t('id#'), align: 'left', sortable: false, value: 'key' },
        { text: this.$t('date'), value: 'dateKeyStr', align: 'left', sortable: false },
        { text: this.$t('scanLabelTotal') + `(${this.selectedDailyScanLabelStats})`, value: 'scanItems', align: 'left', sortable: false }
      ]
      return headers
    },
    clients () {
      const tenantLimitedInfoList = Object.keys(this.$store.getters.allTenantLimitedInfo).length ? this.$store.getters.allTenantLimitedInfo : []
      const warehouseLimitedInfo = Object.keys(this.$store.getters.allWarehouseLimitedInfo).length ? this.$store.getters.allWarehouseLimitedInfo : []
      return [...tenantLimitedInfoList, ...warehouseLimitedInfo]
    },
    processEnv () {
      return process.env.NODE_ENV
    },
    isShowedExcludeVite () {
      switch (this.processEnv) {
        case 'far800':
        case 'fsd915':
        case 'eagle':
          return false
        default:
          return false
      }
    },
    isThirdParty () {
      return Object.keys(thirdPartModuleConfig).includes(this.processEnv)
    },
    isShowMargin () {
      return this.isThirdParty ? thirdPartModuleConfig[this.processEnv]?.includes('margin') : thirdPartModuleConfig['viteusa'].includes('margin')
    },
    isShowMonthlyFee () {
      return this.isThirdParty ? thirdPartModuleConfig[this.processEnv]?.includes('monthlyFee') : thirdPartModuleConfig['viteusa'].includes('monthlyFee')
    },
    clientInShow () {
      if (!this.filterClientType && !this.modeType) return this.clients

      const clients = this.clients.filter(client => {
        let isMatchMode = true
        if (this.modeType) {
          let balanceStat = this.balanceMap.get(client.key)
          if (this.modeType === 'api') isMatchMode = balanceStat?.mode === 'label'
          else if (this.modeType === 'vite') isMatchMode = balanceStat?.mode !== 'label'
        }
        let isMatchClientType = true
        if (this.filterClientType) {
          isMatchClientType = client.type === this.filterClientType
        }

        return isMatchClientType && isMatchMode
      })
      return clients
    },
    comments () {
      return this.applicationInSupport.comments
    },
    accountManagers () {
      const { managers = [] } = this.departments.find(item => item.name === this.clientInEdit.department) || {}
      return managers
    },
    clientInfoText () {
      return `clientKey:${this.clientInEdit.clientKey} // clientName:${this.clientInEdit.clientName} // clientEmail:${this.clientInEdit.email}`
    },
    matchedDailyScanLabelStats () {
      let matchedItems = this.clientInEdit?.scanLabelStatistics?.filter(item => (item.dateKeyStr <= this.endDateString) && (item.dateKeyStr >= this.startDateString)) || []
      return matchedItems.reverse()
    },
    selectedDailyScanLabelStats () {
      let matchedItems = this.clientInEdit?.scanLabelStatistics?.filter(item => (item.dateKeyStr <= this.endDateString) && (item.dateKeyStr >= this.startDateString)) || []
      let nums = matchedItems.reduce((acc, item) => { return item.scanItems + acc }, 0)
      return nums
    },
    scanLabelTotal () {
      let matchedItems = this.clientInEdit?.scanLabelStatistics || []
      let nums = matchedItems.reduce((acc, item) => { return item.scanItems + acc }, 0)
      return nums
    },
    activeTagsList () {
      return Object.entries(this.balances.reduce((prev, cur) => {
        const {tags = []} = cur
        tags.forEach(tag => {
          prev[tag] && (prev[tag] += 1)
          !prev[tag] && (prev[tag] = 1)
        })
        return prev
      }, {}) || {}).sort((a, b) => b['1'] - a['1']).map(item => item[0])
    }
  },
  watch: {
    balances (value) {
      this.selectedBalanceTable = value.find(item => item.clientKey === this.selectedBalanceTable.clientKey) || {}
    },
    adjustBalanceDialog () {
      this.adjustBalance.type = 'balance'
    }
  },
  methods: {
    async refreshBalance (item) {
      try {
        await this.$store.dispatch('refreshApiBalance', item)
      } catch (err) {
        console.log(err)
        alert(err)
      }
    },
    showExportClientsRechargeTransactionDialog () {
      this.exportClientsRechargeTransactionDialog = true
    },
    toggleOverflowStyle (refName) {
      if (![...this.$refs[refName]?.classList || []].includes('text-overflow-hide')) return this.$refs[refName].classList.add('text-overflow-hide')
      this.$refs[refName].classList.remove('text-overflow-hide')
    },
    copyToClipboard (text) {
      let errorMsg = copyText(text)
      if (!errorMsg) return this.$store.dispatch('showToast', {info: this.$t('success'), level: 'success'})
      this.$store.dispatch('showToast', {info: errorMsg.message, level: 'error'})
    },
    toMoney (num) {
      return toMoney(num)
    },
    filterByModule (headersList) {
      if (!(this.isShowMargin || this.isShowMonthlyFee)) return headersList.filter(header => header.value !== 'monthlyFee' && header.value !== 'margin')
      return this.isShowMargin && this.isShowMonthlyFee ? headersList
        : (this.isShowMargin ? headersList.filter(header => header.value !== 'monthlyFee')
          : headersList.filter(header => header.value !== 'margin'))
    },
    changeFeature (feature) {
      if (!this.features.includes(feature.key)) {
        feature.isVisible = false
      }
    },
    showExpenseHistoryDialog (expenseHistory) {
      this.expenseHistory = expenseHistory || []
      this.expenseHistoryDialog = true
    },
    addAdjustBalance () {
      if (!this.canAdjustSystemBalance) return Promise.reject(Error('permission-denied'))
      let payload = {
        clientKey: this.selectedBalance.clientKey,
        clientName: this.selectedBalance.clientName,
        amount: this.adjustBalance.amount,
        note: this.adjustBalance.note,
        type: this.adjustBalance.type,
        keywords: splitKeyword(this.adjustBalance.keywords),
        attachments: this.adjustBalance.attachments || []
      }
      return this.$store.dispatch('adjustSystemBalance', payload)
    },
    showAdjustDialog (item) {
      if (!this.canAdjustSystemBalance || item.orgKey || item.mode === 'label') return
      this.adjustBalanceDialog = true
      this.selectedBalance = item
      this.adjustBalance.amount = 0
      this.adjustBalance.note = ''
    },
    setClientInfo (item) {
      let {
        accountManager,
        lowestBalance,
        clientKey,
        clientName,
        status,
        note = '',
        bond,
        betaFeatures = [],
        type,
        isOverseaCustomer,
        monthlyFee = 0,
        freightSites = [],
        isBlockCreditCardDeposit = false,
        depositFeePercent = 0,
        isDisabledOutbound = false,
        margin = 0,
        eeveeOrgId = '',
        inVisibleFeatures,
        companyName,
        department,
        email,
        tags,
        weChatGroupId = '',
        labelMapping = false,
        scanLabelStatistics = [],
        contractSigning = false,
        contractSignStartDate,
        contractSignEndDate,
        orgKey,
        apiKey,
        mode
      } = item
      let features = [...betaFeatures]
      this.clientInEdit = {
        isModeLabel: mode === 'label' || orgKey || apiKey,
        accountManager,
        isDisabledOutbound,
        lowestBalance,
        depositFeePercent,
        clientKey,
        clientName,
        status,
        features,
        note,
        bond,
        eeveeOrgId,
        type,
        isOverseaCustomer,
        monthlyFee,
        margin,
        isBlockCreditCardDeposit,
        companyName,
        freightSites: !freightSites.length ? this.freightSites.map(site => site.siteId) : freightSites,
        inVisibleFeatures,
        department,
        email,
        tags,
        weChatGroupId,
        labelMapping,
        scanLabelStatistics,
        contractSigning,
        contractSigningValidDate: [contractSignStartDate || new Date(), contractSignEndDate || new Date()]
      }
    },
    showConfigDialog (item) {
      this.cacheInEditClientApiId = item.eeveeOrgId
      this.configDialog = true
      this.setClientInfo(item)
    },
    getExpense (expenseHistory, num) {
      if (!expenseHistory) return 0
      let currentTime = add(new Date(), {months: -num})
      let curKeyStr = `${currentTime.getFullYear()}-${currentTime.getMonth() + 1}`
      let target = expenseHistory.find(item => item.dateKeyStr === curKeyStr)
      return target ? target['expense'] : 0
    },
    getExpenseHeader (num) {
      let currentTime = add(new Date(), {months: -num})
      return `${currentTime.getFullYear()}-${currentTime.getMonth() + 1} Exp`
    },
    showFeatureEditDialog () {
      if (this.featuresManagementButtonDisabled) return
      this.featureDialog = true
      this.features = this.fullBetaFeatures
        .filter(feature => feature.isEnabled)
        .map(feature => feature.key)
      this.eeveeOrgIdDisplay = this.eeveeOrgId
    },
    showOfflineDepositDialog () {
      if (!this.canManageSystemOfflineDeposit) return
      this.OfflineDepositDialog = true
    },
    showApplicationDialog () {
      this.applicationDialog = true
    },
    async editFeature () {
      const authCode = prompt(this.$t('authorizationCodeRequired'), '')
      if (authCode.toLowerCase() === 'adminviteusa') {
        await this.$store.dispatch('editAdminFeature', {features: this.features, eeveeOrgId: this.eeveeOrgIdDisplay || ''})
        this.fullBetaFeatures.forEach(item => {
          if (this.features.includes(item.key)) item.isEnabled = true
        })
      } else {
        this.$store.dispatch('showToast', {level: 'error', info: this.$t('authorizationCodeUnmatchFailedToSave')})
        return Promise.reject(Error(this.$t('authorizationCodeUnmatchFailedToSave')))
      }
    },
    formatPayload (clientInEdit) {
      const targetDepartment = this.departments.find(item => item.name === clientInEdit.department) || {}
      if (targetDepartment) {
        const isExist = targetDepartment.managers?.includes(clientInEdit.accountManager)
        if (!isExist) clientInEdit.accountManager = ''
      } else Object.assign(clientInEdit, { department: '', accountManager: '' })
    },
    async editConfig () {
      this.formatPayload(this.clientInEdit)
      delete this.clientInEdit.isModeLabel
      const isChangedApiId = this.clientInEdit.eeveeOrgId !== (this.cacheInEditClientApiId || '')
      this.clientInEdit.isChangedApiId = isChangedApiId
      const {depositFeePercent = 0, ...rest} = this.clientInEdit
      try {
        if (this.clientInEdit.eeveeOrgId && isChangedApiId && prompt(this.$t('bindApiTip')) !== this.clientInEdit.eeveeOrgId) throw Error(this.$t('apiUnMatch'))
        const { contractSigning, contractSigningValidDate } = rest
        if (contractSigning && (!contractSigningValidDate[0] || !contractSigningValidDate[1])) {
          throw Error(this.$t('contractSigningRequired'))
        }
        await this.$store.dispatch('editClientConfig', rest.type === 'warehouse' ? this.clientInEdit : rest)
        if (this.clientInEdit.eeveeOrgId && isChangedApiId) this.$store.dispatch('bindTenantWithApiId', this.clientInEdit)
      } catch (error) {
        this.$store.dispatch('showToast', {level: 'error', info: error.message})
        throw error
      }
      const matchedWarehouseLimitedInfo = this.$store.getters.allWarehouseLimitedInfo.find(item => item.key === rest.clientKey)
      if (matchedWarehouseLimitedInfo) {
        const { isNeedDepositFee } = matchedWarehouseLimitedInfo
        if (!!+depositFeePercent !== isNeedDepositFee) {
          this.$store.dispatch('updateWarehouseLimitedInfo', {isNeedDepositFee: !!+depositFeePercent, warehouseKey: rest.clientKey})
        }
      }
      const index = this.balances.findIndex(balance => balance.clientKey === rest.clientKey)
      if (index < 0) return
      this.clients[index].betaFeatures = this.clientInEdit.features
    },
    showDetailDialog (item) {
      this.billingDetailDialog = true
      this.clientInView = item.clientKey
      this.clientItemInView = item
    },
    showLabelInvoicesDialog (item) {
      this.labelInvoiceDetailDialog = true
      this.selectedClientKey = item.clientKey
      this.selectedClientInfo = item
    },
    downloadFile (item) {
      this.$store.dispatch('downloadFile', {fullPath: item.fullPath, name: item.name})
    },
    handleApplication (actionType, item) {
      this.$set(item, 'loading', true)
      const payload = {actionType: actionType, ...item}
      this.$store.dispatch('handleApplication', payload)
        .then(result => {
          this.$store.dispatch('showToast', { info: this.$t('operationSucceeded'), level: 'success' })
          this.$set(item, 'loading', false)
          this.refreshTable = !this.refreshTable
        })
        .catch(error => {
          this.$store.dispatch('showToast', { info: `${this.$t('submitApplicationFailed')}: ${error}`, level: 'error' })
          this.$set(item, 'loading', false)
        })
    },
    showCommentsDialog (item) {
      this.commentsDialog = true
      this.applicationInSupport = item
    },
    showDayEndClosingDialog () {
      this.dayEndClosingDialog = true
    },
    exportTableData (detailsData, fileName = '') {
      if (this.isSystemSalesRoleOnly) return
      const now = new Date().toJSON().slice(0, 10)
      const filename = fileName || `Billing-${now}`
      const headers = this.balanceHeaders.map(item => ({ text: item.text, value: item.value }))
      headers.splice(1, 0, { text: this.$t('email'), value: 'email' })
      headers.pop()
      if (detailsData) {
        headers.push({
          text: filename, value: 'details' }
        )
      }
      const data = this.balances.reduce((content, item) => {
        const { clientKey } = item
        const result = headers.map(row => {
          const key = row.value
          switch (key) {
            case 'tags':
              return item.tags ? item.tags.join(',') : ''
            case 'contractSigning':
              return item[key] ? `签收${item.contractSignStartDate.toISOString().slice(0, 10)} ~ ${item.contractSignEndDate.toISOString().slice(0, 10)}` : '未签收'
            case 'status':
            case 'isOverseaCustomer':
              return item[key] ? '开通' : '未开通'
            case 'balance':
              return item.balance && item.balance.toLocaleString()
            case 'margin':
              return item.margin || 0
            case 'monthlyFee':
              return item.monthlyFee || 0
            case 'minBalanceBond':
              return `${(item.lowestBalance || 0)}/${(item.bond || 0)}`
            case 'department':
              return item.accountManager ? (item.department || 'N/A') + ' / ' + item.accountManager : item.department
            case 'createTime':
              return item.createTime ? item.createTime.toJSON().slice(0, 10) : ''
            case 'expense0':
            case 'expense1':
            case 'expense2':
              const [, keyIndex] = key.match(/expense(\w*)/)
              return this.getExpense(item.expenseHistory, keyIndex).toLocaleString()
            case 'details':
              return detailsData[clientKey] || 0
            default:
              return item[key] || ''
          }
        })
        return [...content, result]
      }, [headers.map(item => item.text)])
      const book = xlsx.utils.book_new()
      const sheet = xlsx.utils.aoa_to_sheet(data)
      xlsx.utils.book_append_sheet(book, sheet, 'sheet1')
      xlsx.writeFile(book, `${filename}.xlsx`)
    },
    exportTableDataDetail () {
      this.exportClientsExpenseDetailsDialog = true
    },
    showEditTagsPopup (item) {
      this.currentItemTagKeys = item.tags || []
      this.isShowEditTagsPopup = true
      this.setClientInfo(item)
    },
    async saveTags () {
      this.clientInEdit.tags = this.currentItemTagKeys
      await this.editConfig()
      this.isShowEditTagsPopup = false
    }
  }
}
</script>
<style scoped>
.align-right {
  text-align: right;
}
.refreshBalance {
  margin: 0;
  padding: 0;
  min-width: unset;
}
.modes {
  padding-left: 10px;
}
.openBadge>>>.v-badge__badge {
  font-size: 10px;
  right: -25px !important;
  top: -25px !important;
}
.v-autocomplete.v-input>.v-input__control>.v-input__slot {
  margin-bottom: 0px;
}
.v-text-field__details{
  height: 0px;
}
.text-overflow-hide {
  max-width: 200px;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: rgb(158 162 234);
}
/deep/ .header-hidden {
    display: none;
  }
.menu-list-btn {
  cursor: pointer;
  padding: 10px;
  position: relative;
}
.menu-list-btn:hover:before {
  background-color: currentColor;
}
.menu-list-btn::before {
  border-radius: inherit;
  color: inherit;
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  opacity: 0.12;
  -webkit-transition: .3s cubic-bezier(.25,.8,.5,1);
  transition: .3s cubic-bezier(.25,.8,.5,1);
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/BillingAdmin.vue